import type { AttackDef } from "@arena/shared";

export interface AbilitySlot {
  name: string;
  /** Cooldown left, 1 = just used, 0 = ready. */
  cooldown: number;
}

/** A champion's ability and the predicted steps left on its cooldown → what its button shows. */
export function abilitySlot(def: AttackDef | null, cooldownLeft: number): AbilitySlot | null {
  if (!def) return null;
  return { name: def.name, cooldown: def.cooldown > 0 ? Math.min(1, cooldownLeft / def.cooldown) : 0 };
}

/**
 * S1 and S2 buttons (GDD §4.1): each shows its ability's name and drains
 * a dark wedge while cooling down, like the ★ button fills with the meter.
 * A champion without that ability leaves the button dimmed.
 */
export class AbilityButtons {
  private readonly buttons = [
    document.querySelector<HTMLElement>('[data-button="Special1"]'),
    document.querySelector<HTMLElement>('[data-button="Special2"]'),
  ] as const;
  private rendered = "";

  update(slots: readonly [AbilitySlot | null, AbilitySlot | null]): void {
    const key = JSON.stringify(slots.map((s) => (s ? [s.name, Math.ceil(s.cooldown * 24)] : null)));
    if (key === this.rendered) return;
    this.rendered = key;
    slots.forEach((slot, i) => {
      const button = this.buttons[i];
      if (!button) return;
      button.classList.toggle("inactive", slot === null);
      button.classList.toggle("cooling", slot !== null && slot.cooldown > 0);
      button.style.setProperty("--cd", (slot?.cooldown ?? 0).toFixed(3));
      button.dataset.name = slot?.name ?? "";
      const label = `Abilità ${i + 1}`;
      button.setAttribute("aria-label", slot ? `${label}: ${slot.name}${slot.cooldown > 0 ? " (in ricarica)" : ""}` : `${label}: nessuna`);
    });
  }
}
